
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 430.119 430.119"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M108.716 19.591c21.693-17.051 63.4-21.938 80.561-18.61 17.177 3.307 26.147 12.914 26.257 24.612l.99 149.155c.077 11.714-6.004 22.481-13.525 23.931-7.561 1.418-18.687-5.544-24.803-15.509L99.938 55.275c-6.07-9.978-18.305-14.379 8.778-35.684zm-25.984 283.62l78.788-27.881c10.979-3.893 20.812-14.725 21.917-24.138 1.066-9.409-6.915-20.582-17.74-24.866l-83.228-33.001c-10.833-4.282-23.331 5.873-26.628 22.49 0 0-1.979 57.867 0 69.848 2.002 11.971 15.914 21.459 26.891 17.548zm137.432 13.932c.231-11.747-6.04-21.879-13.936-22.603-7.899-.733-20.439 6.007-27.928 14.953l-54.959 65.904c-7.484 8.956-3.766 29.99 7.141 33.972l57.468 19.961c10.939 3.98 30.203-7.799 30.427-19.509l1.787-92.678zm136.617-15.341l-68.914-19.812c-11.173-3.211-23.858-2.908-28.151.728-4.299 3.594-3.234 14.954 2.395 25.207l43.492 79.598c5.624 10.249 28.114 8.494 34.308-1.452 0 0 26.215-38.676 31.036-53.172 4.82-14.529-3.002-27.886-14.166-31.097zm16.783-111.924c-3.104-10.069-24.651-39.756-36.319-49.875-11.658-10.141-24.992-8.87-32.511.033l-44.412 52.906c-7.523 8.902-9.535 23.022-4.518 31.325 5.013 8.303 18.388 13.007 29.738 10.459l76.82-14.244c13.867-3.327 14.357-20.535 11.202-30.604z","fill":"#FFF"}})])
          )
        }
      }
    